import { EventEmitter } from '@angular/core';
import { VivaBotFaceState } from 'src/app/controls/viva-chat/viva-chat.component';

// Static EventService for demo - matches real app interface
export class EventService {
  // HeyViva events
  static readonly aiBotEmotionChange: EventEmitter<VivaBotFaceState> = new EventEmitter<VivaBotFaceState>();
  static readonly aiBotAwakeState: EventEmitter<boolean> = new EventEmitter<boolean>();
  static readonly aiBotMessage: EventEmitter<string> = new EventEmitter<string>();

  // Network events
  static readonly networkStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // Notification events
  static readonly notificationCount: EventEmitter<number> = new EventEmitter<number>();
  static readonly notificationHistoryUpdated: EventEmitter<any[]> = new EventEmitter<any[]>();

  // Gamification events
  static readonly gameAvailable: EventEmitter<boolean> = new EventEmitter<boolean>();
  static readonly badgeEarned: EventEmitter<any> = new EventEmitter<any>();

  // Other events (stubbed for demo)
  static readonly appDeeplinkEvent: EventEmitter<string> = new EventEmitter<string>();
  static readonly loadingEvent: EventEmitter<number> = new EventEmitter<number>();
  static readonly onAIChatStart: EventEmitter<string> = new EventEmitter<string>();
  static readonly organizationConfigLoaded: EventEmitter<any> = new EventEmitter<any>();
  static readonly myProfileUpdated: EventEmitter<any> = new EventEmitter<any>();
  static readonly healthScoreUpdated: EventEmitter<any> = new EventEmitter<any>();
  static readonly faceScanHistoryUpdated: EventEmitter<any> = new EventEmitter<any>();
  static readonly onBiometricListUpdated: EventEmitter<any> = new EventEmitter<any>();
  static readonly questionnaireListUpdated: EventEmitter<any[]> = new EventEmitter<any[]>();
  static readonly questionnaireHistoryUpdated: EventEmitter<any> = new EventEmitter<any>();
  static readonly userUpdated: EventEmitter<any> = new EventEmitter<any>();
  static readonly environmentLoaded: EventEmitter<any> = new EventEmitter<any>();
}

